export function isMobile() {
    var ua = navigator.userAgent.toLowerCase();

    if(/(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(ua)) {
        return true;
    }
    else if(/(mobi|ipod|phone|blackberry|opera mini|fennec|minimo|symbian|psp|nintendo ds|archos|skyfire|puffin|blazer|bolt|gobrowser|iris|maemo|semc|teashark|uzard)/.test(ua)) {
        return true;
    }
    
    return false;
}

export function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

export function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

export function eraseCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

export function requiredFieldsEvents(fields) {
    fields.forEach(item => {
        const parent = item.closest('.field');

        if (item.tagName == "INPUT" || item.tagName == "TEXTAREA") {
            parent.classList.remove('error');

            if (item.type == "checkbox" || item.type == "radio") {
                item.onchange = () => {
                    validateFields(fields);
                }
            }

            else {
                item.oninput = () => {
                    validateFields(fields);
                }
            }
        }
        else {
            const inputs = item.querySelectorAll('input');

            inputs.forEach(input => {
                input.onchange = () => {
                    validateFields(fields);
                }
            })
        }
    })
}

export function removeRequiredFieldsEvents(fields) {
    fields.forEach(item => {
        const parent = item.closest('.field');
        if (item.tagName == "INPUT" || item.tagName == "TEXTAREA") {
            parent.classList.remove('error');

            if (item.type == "checkbox" || item.type == "radio") {
                item.onchange = () => {}
            }

            else {
                item.oninput = () => {}
            }
        }
        else {
            const inputs = item.querySelectorAll('input');

            inputs.forEach(input => {
                input.onchange = () => {}
            })
        }
    })
}

export function validateFields(fields) {

    var error = [];

    requiredFieldsEvents(fields);

    fields.forEach(item => {

        const parent = item.closest('.field');
        const errorMessage = parent.querySelector('.field__error');
        const recaptcha = item.classList.contains('g-recaptcha');

        if (parent.checkVisibility() == false) {
            return;
        }

        if (item.tagName == "INPUT" || item.tagName == "TEXTAREA") {
            parent.classList.remove('error');

            if (item.type == "checkbox" || item.type == "radio") {
                if (!item.checked) {
                    parent.classList.add('error');
                    error.push(item);
                }
            }

            else if (item.type == "email" && item.classList.contains('js-validate-field-email-confirm') && item.value.length > 0) {
                const email = item.closest('form').querySelector('.js-validate-field-email').value;

                if (email !== item.value) {
                    errorMessage.innerHTML = ParamsData.translations.form.emails;
                    parent.classList.add('error');
                    error.push(item);
                }
            }

            else if (item.type == "email" && item.value.length > 0) {
                var regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

                if (!item.value.match(regex)) {
                    errorMessage.innerHTML = ParamsData.translations.form.format;
                    parent.classList.add('error');
                    error.push(item);
                }
            }

            else if (item.type == "tel" && item.value.length > 0) {
                var testValue = item.value;
                testValue = testValue.replace(/\s+/g, '');

                var regex = /^\d{9,15}$/;

                if (!testValue.match(regex)) {
                    errorMessage.innerHTML = ParamsData.translations.form.format;
                    parent.classList.add('error');
                    error.push(item);
                }
            }

            else if (item.type == "password" && item.classList.contains('js-validate-field-password-confirm') && item.value.length > 0) {

                const password = item.closest('form').querySelector('.js-validate-field-password').value;

                if (password !== item.value) {

                    errorMessage.innerHTML = ParamsData.translations.form.passwords;
                    parent.classList.add('error');
                    error.push(item);
                }
            }

            else if (item.tagName == "TEXTAREA" && item.value.length > item.getAttribute('maxlength')) {
                errorMessage.innerHTML = ParamsData.translations.form.format;
                parent.classList.add('error');
                error.push(item);
            }

            else {
                if (item.value.length <= 0) {
                    errorMessage.innerHTML = ParamsData.translations.form.default;
                    parent.classList.add('error');
                    error.push(item);
                }
            }
        }

        else if (recaptcha) {
            parent.classList.remove('error');
            var response = grecaptcha.getResponse(item.dataset.id);

            if (response.length <= 0) {
                parent.classList.add('error');
                error.push(item);
            }
        }

        else {
            const checked = item.querySelectorAll('input:checked');

            parent.classList[checked.length <= 0 ? 'add' : 'remove']('error');

            if (checked.length <= 0) {
                error.push(item);
            }
        }
    })

    return error;
}